const ERRORS = {
  switchAccounts: 'Something went wrong while switching accounts.',
  quickBuy: 'Something went wrong. Please try again.'
};

export default ERRORS;
